import React from "react";
import AdminAssignLeads from "../AdminAssignLeads";
import { indiaOperations } from "../../utils/indiaOperationsSource";

/** India "Lead Pool" page: the Australian Lead Pool on India data (₹). */
const IndiaAssignLeads = () => <AdminAssignLeads source={indiaOperations} />;

export default IndiaAssignLeads;
